var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreditCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62.886,
    height: 48.087,
    viewBox: "0 0 62.886 48.087",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16456",
    "data-name": "Group 16456",
    transform: "translate(-7226.044 13192.355)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16448",
    "data-name": "Group 16448",
    transform: "translate(-139 3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16447",
    "data-name": "Group 16447",
    transform: "translate(858.044 392.645)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24064",
    "data-name": "Path 24064",
    d: "M52.844,15.457H10.054A10.062,10.062,0,0,0,.006,25.526V53.475A10.062,10.062,0,0,0,10.054,63.544h42.79A10.062,10.062,0,0,0,62.892,53.475V25.526A10.062,10.062,0,0,0,52.844,15.457Zm-42.79,3.151h42.79a6.9,6.9,0,0,1,6.9,6.917v.238H3.143v-.238a6.9,6.9,0,0,1,6.91-6.917Zm42.79,41.784H10.054a6.9,6.9,0,0,1-6.9-6.917V36.308h56.6V53.475a6.9,6.9,0,0,1-6.91,6.917Z",
    transform: "translate(6506.994 -13603.457)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8068",
    "data-name": "Rectangle 8068",
    width: 14,
    height: 5,
    rx: 2,
    transform: "translate(7376 -13162)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/credit_card.e3f1629c5128f10ba675a1a7e158b860.svg";
export { ForwardRef as ReactComponent };